import { useState, useEffect } from 'react';
import profileCompletionService from '../services/profileCompletionService';

export const useProfileCompletion = () => {
    const [profileCompletion, setProfileCompletion] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Get initial state
        const initial = profileCompletionService.getProfileCompletion();
        if (initial) {
            setProfileCompletion(initial);
            setLoading(false);
        }

        // Subscribe to profile changes
        const unsubscribe = profileCompletionService.subscribe((newProfile, newLoading) => {
            console.log('[useProfileCompletion] Profile updated:', newProfile);
            // Only update if actually changed
            setProfileCompletion(prev => {
                if (JSON.stringify(prev) !== JSON.stringify(newProfile)) {
                    return newProfile;
                }
                return prev;
            });
            setLoading(newLoading);
        });

        // Cleanup subscription on unmount
        return unsubscribe;
    }, []);

    return {
        profileCompletion,
        loading,
        refreshProfile: () => profileCompletionService.fetchProfileCompletion(),
        isComplete: profileCompletion?.isComplete || false,
        percentage: profileCompletion?.percentage || 0
    };
};